/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $, Modernizr, FontFaceObserver) {
	"use strict";

	var LARGE_SCREEN_SIZE = 960;

	function isMobile() {
		var width = $(window).width();
		return width < LARGE_SCREEN_SIZE;
	}

	function openNavigation(toggle, context) {
		toggle.addClass("is-active");
		var navId = toggle.attr("for");
		$("#" + navId, context).addClass("is-active");
		$("body", context).addClass("mobile-menu-active");
	}

	function collapseAllMenus(except) {
		var expanded = $(".menu-item--expanded").not(except);
		expanded.removeClass("menu-item--expanded");
		expanded.children(".menu-item-link").attr("aria-expanded", "false");
		expanded.children(".inner-menu-container").removeAttr("style");
	}

	function closeNavigation(toggle, context) {
		collapseAllMenus();

		toggle.removeClass("is-active");
		var navId = toggle.attr("for");
		$("#" + navId, context).removeClass("is-active");
		$("body", context).removeClass("mobile-menu-active");
	}

	function handleNavigationToggle(context) {
		$("#nav-toggle", context).on("click", function (event) {
			if ($(this).hasClass("is-active")) {
				closeNavigation($(this), context);
			} else {
				openNavigation($(this), context);
			}
		});
	}

	function isExpanded(item) {
		return item.hasClass("menu-item--expanded");
	}

	function expandMenuItem(item) {
		collapseAllMenus(item);

		var innerMenu = item
			.children(".inner-menu-container")
			.children(".menu");
		var innerMenuHeight = innerMenu.height();

		item.addClass("menu-item--expanded");
		item.children(".menu-item-link").attr("aria-expanded", "true");
		if (innerMenuHeight === 0) {
			item.children(".inner-menu-container").css("height", "auto");
		} else {
			item.children(".inner-menu-container").css(
				"height",
				innerMenuHeight
			);
		}

		innerMenu.attr("aria-hidden", "false");
		item.children(".inner-menu-container").slideDown();
	}

	function collapseMenuItem(item) {
		item.removeClass("menu-item--expanded");
		item.children(".menu-item-link").attr("aria-expanded", "false");
		item.children(".inner-menu-container").removeAttr("style");
		item.children(".inner-menu-container")
			.children(".menu")
			.attr("aria-hidden", "true");
		item.children(".inner-menu-container").hide();
	}

	function toggleMenuItemExpanded(item) {
		if (isExpanded(item)) {
			collapseMenuItem(item);
		} else {
			expandMenuItem(item);
		}
	}

	function handleNavigationInnerExpand(context) {
		$(".menu-item--below", context).on("mouseenter", function () {
			// If screen size is mobile, do not proceed with hover
			if (isMobile()) {
				return;
			}
			expandMenuItem($(this));
		});

		$(".menu-item--below", context).on("mouseleave", function () {
			// If screen size is mobile, do not proceed with hover
			if (isMobile()) {
				return;
			}
			collapseMenuItem($(this));
		});

		$(".menu-item-link--below", context).on("click", function (event) {
			event.stopPropagation();
			event.preventDefault();

			var li = $(this).parents("li");
			var childLinks = $(this).children("a");
			var hasLink = childLinks.length > 0;
			var expanded = isExpanded(li);

			// If inner menu has already been expanded:
			//   If this item has a link, follow default behavior of click
			//   Otherwise, collapse the inner menu
			// Otherwise, expand the inner menu
			if (expanded) {
				//   If this item has a link, follow default behavior of click
				//   Otherwise, collapse the inner menu
				if (hasLink) {
					childLinks.first().click();
				} else {
					collapseMenuItem(li);
				}
			} else {
				expandMenuItem(li);
			}
		});

		$(".menu-item", context).on("keydown", function (event) {
			var code = event.keyCode || event.which;
			var li = $(this).parents("li");
			if (code == 27) {
				// ESC
				$(this).parents("li:first").find("button:first").focus();
				collapseMenuItem(li);
				return;
			} else if (code == 37) {
				// ARROW LEFT
				$(this).prev("li").children("a, button").focus();

				event.stopPropagation();
				event.preventDefault();
			} else if (code == 39) {
				// ARROW RIGHT
				$(this).next("li").children("a, button").focus();

				event.stopPropagation();
				event.preventDefault();
			} else if (code == 40) {
				// ARROW DOWN
				$(this).next().find("a").focus();
				event.stopPropagation();
				event.preventDefault();
			} else if (code == 38) {
				// ARROW UP
				$(this).prev().find("a").focus();
				event.stopPropagation();
				event.preventDefault();
			} else if (code == 36) {
				// HOME
				$(".menu .menu-level-0:first button").focus();
				event.stopPropagation();
				event.preventDefault();
			} else if (code == 35) {
				// END
				$(".menu .menu-level-0:last button").focus();
				event.stopPropagation();
				event.preventDefault();
			}
		});

		// If expanded menu item is tabbed on, tab into lower menu
		$(".menu-item-link--below", context).on("keydown", function (event) {
			var code = event.keyCode || event.which;

			var li = $(this).parents("li");
			if (code == 27) {
				// ESC
				collapseMenuItem(li);
				return;
			} else if (code == 39) {
				// ARROW RIGHT
				li.next().focus();
				return;
			} else if (code == 37) {
				// ARROW LEFT
				li.prev().focus();
				return;
			}

			var expanded = isExpanded(li);
			if (!expanded) {
				return;
			} else if (event.shiftKey) {
				collapseMenuItem(li);
				return;
			}
			if (event.shiftKey) {
				collapseMenuItem(li);
				return;
			} else if (code == 40) {
				// ARROW DOWN
				li.children(".inner-menu-container")
					.find(".menu-item-link:first a")
					.focus();
				return;
			} else if (code == 9) {
				//TAB
				return;
				// li.children('.inner-menu-container').find('.menu-item-link:first a').focus();
				// event.stopPropagation();
				// event.preventDefault();
			} else if (code == 36) {
				// HOME
				$(".menu .menu-level-0:first button").focus();
				event.stopPropagation();
				event.preventDefault();
			} else if (code == 35) {
				// END
				$(".menu .menu-level-0:last button").focus();
				event.stopPropagation();
				event.preventDefault();
			}
		});

		// If last item of lower menu is tabbed off and onto a new element outside the menu,
		// close the menu
		$(".menu-level-1", context).on("focusout", function (event) {
			// If the next focused element has the same parent menu item, do not collapse menu
			if (
				$(this)
					.parents(".menu-item")
					.is(
						$(event.originalEvent.relatedTarget).parents(
							".menu-item"
						)
					)
			) {
				return;
			}

			var menu = $(this).parents(".menu").first();
			var level0 = menu
				.parents(".inner-menu-container")
				.first()
				.parents(".menu-level-0")
				.first();
			collapseMenuItem(level0);
		});

		// Propagate clicks on non-expandanble menu items
		$(".menu-item-link:not(.menu-item-link--below)", context).on(
			"click",
			function (event) {
				var childLinks = $(this).children("a");
				var hasLink = childLinks.length > 0;
				if (hasLink) {
					childLinks[0].click();
				}
			}
		);

		// On desktop and non-expandable mobile links, prevent link propagation
		// On mobile, if link can be expanded and has not yet been, prevent default
		$(".menu-item-link>a", context).on("click", function (event) {
			if (!isMobile()) {
				event.stopPropagation();
			}

			var li = $(this).parent().parent();
			var expandable = li.hasClass("menu-item--below");
			var expanded = isExpanded(li);
			if (expandable && !expanded) {
				event.preventDefault();
			} else {
				event.stopPropagation();
			}
		});
	}

	function handleHideSeparator(context) {
		var baseOffset = $(
			".menu-item.menu-level-0:first-child",
			context
		).offset();
		if (baseOffset) {
			var baseTopOffset = baseOffset.top;
			$(".menu-item.menu-level-0:not(:first-child)", context).each(
				function () {
					var currTopOffset = $(this).offset().top;
					var hasHideSeparator = $(this).hasClass(
						"menu-item-hide-separator"
					);
					if (currTopOffset !== baseTopOffset) {
						if (!hasHideSeparator) {
							$(this).addClass("menu-item-hide-separator");
						}
						baseTopOffset = currTopOffset;
					} else if (hasHideSeparator) {
						$(this).removeClass("menu-item-hide-separator");
					}
				}
			);
		}
	}

	function handleWindowResize(context) {
		$(window).on("resize", function () {
			handleHideSeparator(context);
		});
	}

	function initNavigation(context) {
		var font = new FontFaceObserver("priori-sans");

		font.load().then(function () {
			handleHideSeparator(context);
		});

		$(".inner-menu-container", context).hide();
	}

	Drupal.behaviors.handleNavigationToggle = {
		attach: handleNavigationToggle,
	};
	Drupal.behaviors.handleNavigationInnerExpand = {
		attach: handleNavigationInnerExpand,
	};
	Drupal.behaviors.handleWindowResize = { attach: handleWindowResize };
	Drupal.behaviors.initNavigation = { attach: initNavigation };
})(Drupal, jQuery, Modernizr, FontFaceObserver);
